import React from "react";
import { Link } from "react-router-dom";
import config from "../data/siteConfig";
import Footer from "./Footer";
import { Ornament, ScallopDivider } from "./Decor";
import { FiArrowLeft } from "react-icons/fi";

function Block({ text }) {
  // an array becomes a bullet list; an object becomes a sub-heading group;
  // a string becomes a paragraph
  if (Array.isArray(text)) {
    return (
      <ul className="mt-3 space-y-2 pl-5">
        {text.map((t, i) => (
          <li key={i} className="list-disc text-coffee-700/90 marker:text-gold-deep">
            {t}
          </li>
        ))}
      </ul>
    );
  }
  if (text && typeof text === "object") {
    return (
      <div className="mt-5">
        <h3 className="font-display text-lg text-coffee-800">{text.h}</h3>
        {text.body.map((b, i) => (
          <Block key={i} text={b} />
        ))}
      </div>
    );
  }
  return <p className="mt-3 text-coffee-700/90">{text}</p>;
}

export default function LegalPage({ doc }) {
  return (
    <div className="min-h-screen bg-parchment">
      {/* slim header */}
      <header className="sticky top-0 z-50 border-b border-gold/30 bg-parchment/95 backdrop-blur">
        <div className="container-x flex items-center justify-between gap-4 py-2.5">
          <Link to="/" className="flex items-center gap-3">
            <img src={config.brand.logo} alt={config.brand.name} className="h-12 w-auto drop-shadow" />
            <span className="leading-tight">
              <strong className="block font-display text-lg tracking-wide text-coffee-800">
                Shree Abhushan Jewellers
              </strong>
              <small className="block text-[0.66rem] uppercase tracking-[0.28em] text-coffee-500">
                Bhachau, Kutch
              </small>
            </span>
          </Link>
          <Link className="btn btn-gold" to="/">
            <FiArrowLeft /> Back to Home
          </Link>
        </div>
        <ScallopDivider className="block h-3 w-full" />
      </header>

      {/* content */}
      <main className="container-x max-w-4xl py-16 md:py-20">
        <div className="text-center">
          <span className="eyebrow">Legal</span>
          <h1 className="mt-2 font-display text-3xl text-coffee-800 sm:text-4xl">{doc.title}</h1>
          <div className="mt-4 flex justify-center"><Ornament /></div>
          {doc.updated && (
            <p className="mt-4 text-sm text-coffee-500">{doc.updated}</p>
          )}
        </div>

        {doc.intro && (
          <p className="mt-10 text-coffee-700/90">{doc.intro}</p>
        )}

        <div className="mt-8 space-y-9">
          {doc.sections.map((s, si) => (
            <section key={si}>
              {s.heading ? (
                <>
                  <h2 className="font-display text-xl text-coffee-800 sm:text-2xl">{s.heading}</h2>
                  <div className="mt-1 h-px w-14 bg-gold/50" />
                </>
              ) : null}
              {s.body.map((b, i) => (
                <Block key={i} text={b} />
              ))}
            </section>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}
